export default {
  view: 'client.view_clientagreement',
  view_managed: 'client.view_clientagreement_managed',
  add: 'client.add_clientagreement',
  change: 'client.change_clientagreement',
  delete: 'client.delete_clientagreement',
};
